import type { ProductLogoMediumProps } from "../types";

export function ProductLogoMediumContracts({
  size = 40,
  ...props
}: ProductLogoMediumProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 672 672"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="672" height="672" rx="100" fill="#1A2142" />
      <path
        d="M276.603 277.161C285.976 267.789 301.172 267.789 310.544 277.161L361.456 328.073L362.121 328.722C376.225 342.129 398.529 341.912 412.368 328.073L420.853 319.588C434.912 305.529 434.912 282.735 420.853 268.676L369.941 217.764C360.569 208.392 360.569 193.196 369.941 183.823C388.687 165.078 419.079 165.078 437.824 183.823L522.676 268.676C541.422 287.421 541.421 317.813 522.676 336.558L348.728 510.507C341.699 517.536 330.302 517.536 323.272 510.507C316.243 503.477 316.243 492.08 323.272 485.051L395.397 412.926C400.084 408.24 400.084 400.642 395.397 395.955C390.711 391.269 383.113 391.269 378.427 395.955L306.302 468.08C299.272 475.11 287.875 475.11 280.846 468.08C273.817 461.051 273.817 449.654 280.846 442.624L352.971 370.5C357.657 365.813 357.657 358.215 352.971 353.529L352.749 353.313C348.048 348.844 340.613 348.916 336 353.529L263.875 425.654C256.846 432.683 245.449 432.683 238.42 425.654C231.39 418.624 231.39 407.227 238.42 400.198L310.544 328.073C315.231 323.387 315.231 315.789 310.544 311.103L310.323 310.886C305.696 306.488 298.422 306.488 293.796 310.886L293.574 311.103L221.449 383.227C214.42 390.257 203.023 390.257 195.993 383.227C188.964 376.198 188.964 364.801 195.993 357.772L276.603 277.161Z"
        fill="white"
      />
      <path
        d="M234.177 183.823C252.922 165.078 283.314 165.078 302.059 183.823L399.64 281.404C406.669 288.433 406.669 299.83 399.64 306.86C392.61 313.889 381.213 313.889 374.184 306.86L319.03 251.706C305.19 237.866 282.887 237.65 268.783 251.057L268.118 251.706L183.265 336.558C173.893 345.931 158.697 345.931 149.324 336.558C130.579 317.813 130.579 287.421 149.324 268.676L234.177 183.823Z"
        fill="#57D7D9"
      />
    </svg>
  );
}
